import { forwardRef } from 'react';
import { Stack as MuiStack, StackProps } from '@mui/material';

export { type StackProps } from '@mui/material';

export const Stack = forwardRef<HTMLDivElement, StackProps>(
  function Stack(props, ref) {
    return <MuiStack ref={ref} {...props} />;
  },
);
